export default {
  browse: {
    title: "Entdecken",
    sections: {
      advancedTools: "Erweiterte Tools",
      freeTools: "Kostenlose Tools",
    },
    gamesOfPeriod: "Spiele des {{period}}",
    periods: {
      day: "Tages",
      week: "Woche",
    },
    gameCount_one: "{{count}} Spiel",
    gameCount_other: "{{count}} Spiele",
  },
};
